import { z } from 'zod'

import { AddressSchema } from '#app/routes/mocra+/_form+/components/addresses/schema.ts'

export const FACILITY_TYPE_OPTIONS = [
	{ value: 'owned', label: 'Owned / operated facility' },
	{ value: 'contract', label: 'Contract manufacturer (CMO)' },
] as const

export const REGISTRATION_STATUS_OPTIONS = [
	{ value: 'registered', label: 'Registered' },
	{ value: 'pending', label: 'Pending submission' },
	{ value: 'not_started', label: 'Not started yet' },
] as const

export const FEI_STATUS_PER_FACILITY = [
	{ value: 'present', label: 'FEI issued' },
	{ value: 'applied', label: 'Application submitted' },
	{ value: 'not_applied', label: 'Not applied yet' },
] as const

export const FacilityEntrySchema = z.object({
	name: z
		.string({
			required_error: 'Enter the facility name.',
		})
		.min(1, 'Enter the facility name.'),
	type: z.enum(
		FACILITY_TYPE_OPTIONS.map((option) => option.value) as [
			(typeof FACILITY_TYPE_OPTIONS)[number]['value'],
			...string[],
		],
	),
	address: AddressSchema,
	registrationStatus: z.enum(
		REGISTRATION_STATUS_OPTIONS.map((option) => option.value) as [
			(typeof REGISTRATION_STATUS_OPTIONS)[number]['value'],
			...string[],
		],
	),
	feiStatus: z.enum(
		FEI_STATUS_PER_FACILITY.map((option) => option.value) as [
			(typeof FEI_STATUS_PER_FACILITY)[number]['value'],
			...string[],
		],
	),
	feiNumber: z.string().optional(),
})

export type FacilityEntry = z.infer<typeof FacilityEntrySchema>
